import { ChangeEvent, FC, useEffect, useState } from "react";
import { AddSquareIcon, ArrowSmallDownIcon } from "../../../assets";
import { Button, CheckBox, SearchInput, StaffItem } from "../../../components";
import { AddNewStaff } from "../../../modals";
import { IStaff } from "../../../models";
import { getAllStaff } from "../../../services/staff.service";
import styles from "./styles.module.scss";
import PulseLoader from "react-spinners/PulseLoader";
import { getUser } from "../../../utils/tokenStorage";

const StaffManagement: FC = (): JSX.Element => {
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [search, setSearch] = useState<string>("");
  const [staff, setStaff] = useState<IStaff[]>([]);
  const [searchedStaff, setSearchedStaff] = useState<IStaff[]>([]);
  const me = getUser();
  const onChangeSearch = (e: ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onGetAllStaff = async () => {
    try {
      setIsLoading(true);
      const { data } = await getAllStaff();
      if (data?.success) {
        setStaff(data?.admins);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (search) {
      const filteredStaff = staff.filter((item) => {
        if (item.fullName.toLowerCase().includes(search.toLowerCase())) {
          return item;
        }
      });
      setSearchedStaff(filteredStaff);
    }
  }, [search, staff]);

  useEffect(() => {
    onGetAllStaff();
  }, []);

  if (me?.type !== "Admin") {
    return <></>;
  }

  return (
    <>
      <AddNewStaff
        isOpen={isOpenModal}
        setIsOpen={setIsOpenModal}
        onGetAllStaff={onGetAllStaff}
      />
      <div className={styles.wrapper}>
        <header className={styles.header}>
          <h4 className={styles.title}>Staff Management</h4>
        </header>
        <section className={styles.contentContainer}>
          <div className={styles.searchContainer}>
            <SearchInput
              placeholder="Search"
              value={search}
              onChange={onChangeSearch}
            />

            <Button
              leftIcon={<AddSquareIcon />}
              title={"Add New"}
              size={"small"}
              styleType={"filled"}
              style={{ width: "160px" }}
              onClick={() => setIsOpenModal(true)}
            />
          </div>
          <div className={styles.sectionHeader}>
            <CheckBox isChecked={false} setIsChecked={() => {}} />
            <div className={styles.userBlock}>
              <p>User</p> <ArrowSmallDownIcon />
            </div>
            <div className={styles.emailBlock}>
              <p>Email</p> <ArrowSmallDownIcon />
            </div>
            <div className={styles.roleBlock}>
              <p>Role</p> <ArrowSmallDownIcon />
            </div>
          </div>
          <div className={styles.staffContainer}>
            {isLoading && (
              <div className={styles.loaderWrapper}>
                <PulseLoader color={"#7D4AFB"} />
              </div>
            )}
            {!isLoading && search
              ? searchedStaff.map((item, index) => (
                  <StaffItem
                    key={item.id}
                    item={item}
                    onGetAllStaff={onGetAllStaff}
                  />
                ))
              : !isLoading &&
                staff.map((item, index) => (
                  <StaffItem
                    item={item}
                    key={item?.id}
                    onGetAllStaff={onGetAllStaff}
                  />
                ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default StaffManagement;
